import { TripContext } from 'contexts';
import _ from "lodash";
import React, { FC, Fragment, useContext, useState } from "react";
import { useOrderItemService } from 'services';
import { OrderItemChange } from "services/types";
import "./reconcile-reason-grid.scss";
import { ReconcileReasonRow } from "./reconcile-reason-row";
import { VerifyValuePopUp } from 'components/pop-up/verify-value-pop-up/verify-value-pop-up';
import { envConfig } from 'config';

type Props = {
  itemId: number,
  countedQuantity: number,
  onQuantityAdjusted: (customerPoNumber: string | null, quantity: number) => void
};

export const ReconcileReasonGrid: FC<Props> = ({ itemId, countedQuantity, onQuantityAdjusted }) => {
  const config = envConfig();

  const tripContext = useContext(TripContext)
  const { formatChange } = useOrderItemService()
  const [showWarningMessage, setShowWarningMessage] = useState<boolean>(true)

  const changes: OrderItemChange[] = tripContext.orderItemChanges.filter(cw => cw.orderItemId == itemId).sort((a, b) => a.reconcileReasonId < b.reconcileReasonId ? -1 : a.reconcileReasonId > b.reconcileReasonId ? 1 : 0)

  const featureFlagVerifyPopUp: boolean = `${config.FEATURE_FLAG_VERIFY_POP_UP}` === 'true'

  return (
    <Fragment>
      <div className={'reconcile-reason-grid-heading'}>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '60%' }}>Reason</div>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '20%' }}>Quantity</div>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '20%' }}>Done</div>
      </div>
      <Fragment>
        {changes.map((change, changeIndex) => {
          const formattedChanges = formatChange(change)
          return formattedChanges.map((formattedChange, formattedIndex) => {
            const [description, quantity] = formattedChange

            return quantity > 0 &&
              <>
                {featureFlagVerifyPopUp &&
                  <VerifyValuePopUp
                    isVisible={quantity > config.QUANTITY_LIMIT_FOR_DISCREPANCY && showWarningMessage}
                    itemId={itemId}
                    countedQuantity={countedQuantity}
                    onConfirm={(quantity: number) => {
                      setShowWarningMessage(false)
                      onQuantityAdjusted(itemId.toString(), quantity)
                    }} />
                }

                <ReconcileReasonRow
                  key={`${changeIndex}-${formattedIndex}`}
                  changeId={change.id}
                  quantity={quantity}
                  reconcileDescription={description}
                />
              </>
          })
        })}
      </Fragment>
    </Fragment>
  )
}
